import wx from 'weixin-js-sdk'
import axios from 'axios'

var wechat = (function() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
})()

export default function V_SHARE(title, desc) {
    if (wechat) {
        var wxlink = "https://xiaomi.event1.cn/",
            data = new FormData();
        data.append('url', wxlink);
        axios.post("https://chat-admin.event1.cn/api/Wechat/get_config", data).then(res => {
            let data = res.data.data;
            console.log(data)
            wx.config({
                appId: data.appId,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'scanQRCode'
                ]
            })
            wx.ready(function() {
                iniShare({
                    title: title, 
                    desc: desc,
                    link: 'https://xiaomi.event1.cn/',
                    logo: 'https://oss.eventnet.cn/H5/mi/share.jpg'
                })
            })
            wx.error(function(res) {
                console.log(res.errMsg)
            })
        }).catch(function(error) {
            console.log(error);
        });
    }

}

function iniShare(data) {
    var shareData = {
        title: data.title,
        desc: data.desc,
        link: data.link,
        imgUrl: data.logo,
        trigger: function(res) {},
        success: function(res) {},
        cancel: function(res) {},
        fail: function(res) {}
    }

    //好友
    wx.onMenuShareAppMessage(shareData)
        //朋友圈
    shareData = {
        title: data.title,
        link: data.link,
        imgUrl: data.logo,
        trigger: function(res) {},
        success: function(res) {},
        cancel: function(res) {},
        fail: function(res) {}
    }
    wx.onMenuShareTimeline(shareData)
}


// WEBPACK FOOTER //
// ./src/tz.js